<app-base-list-wrapper [baseListComponent]="this">
</app-base-list-wrapper>
